import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';

export const BASIC_EVENT_TOGGLE = gql`
  mutation BasicEventToggle($input: BasicEventToggleInput!) {
    basicEventToggle(input: $input) {
      errors {
        field
        messages
      }
      message
    }
  }
`;

export const BASIC_EVENT_RENAME = gql`
  mutation BasicEventRename($input: BasicEventRenameInput!) {
    basicEventRename(input: $input) {
      errors {
        ...ErrorFields
      }
      message
    }
  }
  ${ErrorFragment}
`;

export const BASIC_EVENT_ADD_CATEGORY = gql`
  mutation BasicEventAddCategory($input: BasicEventEditCategoryInput!) {
    basicEventAddCategory(input: $input) {
      errors {
        ...ErrorFields
      }
      message
    }
  }
  ${ErrorFragment}
`;

export const BASIC_EVENT_REMOVE_CATEGORY = gql`
  mutation BasicEventRemoveCategory($input: BasicEventEditCategoryInput!) {
    basicEventRemoveCategory(input: $input) {
      errors {
        ...ErrorFields
      }
      message
    }
  }
  ${ErrorFragment}
`;

export const BASIC_EVENT_UPDATE_DESCRIPTION = gql`
  mutation BasicEventUpdateDescription(
    $input: BasicEventUpdateDescriptionInput!
  ) {
    basicEventUpdateDescription(input: $input) {
      errors {
        ...ErrorFields
      }
      message
    }
  }
  ${ErrorFragment}
`;
